<template>
  <div>
    <v-card outlined elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="pa-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">
            Contact(s) lié(s)
          </div>
          <v-spacer />
          <!--<v-btn v-if="!isEditing" icon white elevation="0" @click="removeContact">
            <v-icon color="white">mdi-account-minus</v-icon>
          </v-btn>-->
          <v-btn v-if="!isEditing && !disabled" icon white elevation="0" @click="pickAddContact">
            <v-icon color="white">mdi-account-plus</v-icon>
          </v-btn>
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showCard">
          <v-card-text class="d-flex flex-wrap grey lighten-4">
            <div v-if="contacts.length === 0" class="mt-4">
              Aucun contact trouvé
            </div>
            <div v-else>
              <v-chip
                v-for="(contact, index) in contacts"
                :key="contact.uuid"
                :color="valueChanged(index) ? 'green' : 'red'"
                dark
                close
                class="mr-1 mt-4"
                :close-icon="!disabled ? 'mdi-close-circle' : ''"
                @click="showUser(contact.uuid)"
                @click:close="removeContact(contact)"
              >
                <v-icon left>mdi-account-circle</v-icon>
                {{ `${contact.firstname} ${contact.lastname}` }}
              </v-chip>
            </div>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
    <ConfirmRemoveContact :contact="selectedContact" :content="content" :save-customer="saveCustomer" />
    <!--<RemoveContact :contacts="contacts" :content="content" :save-customer="saveCustomer" />-->
  </div>
</template>

<script>
import { EventBus } from '../../mixins';
import { utils } from '@/mixins/index';
import ConfirmRemoveContact from '@/components/profile/ConfirmRemoveContact';
// import RemoveContact from '@/components/profile/RemoveContact';

const _ = require('lodash');

export default {
  name: 'ContactsCard',
  components: { ConfirmRemoveContact },
  mixins: [utils],
  props: {
    isEditing: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showCard: true,
      selectedContact: null
    };
  },
  computed: {
    contacts () {
      let contactsList = [];
      if (this.content) {
        const contacts = this.content.contacts || [];
        const contacts_from = this.content.contacts_from || [];
        contactsList = _.concat(contacts, contacts_from);
        contactsList = _.uniqBy(contactsList, 'uuid');
        contactsList = (contactsList || []).filter(c => c.uuid !== this.content.uuid);
      }
      return contactsList;
    }
  },
  methods: {
    pickAddContact () {
      this.$store.commit('setAddContactMode', {
        active: true,
        customer_uuid: this.content.uuid
      });
      this.homepage();
    },
    // removeContact () {
    //   EventBus.$emit('startRemoveContact');
    // },
    removeContact (contact) {
      this.selectedContact = contact.uuid;
      EventBus.$emit('removeContactConfirm');
    },
    showUser (uuid) {
      this.$router.push({
        name: 'Customer',
        params: { uuid: uuid }
      });
    },
    valueChanged (index) {
      if (this.contentAlteredValues && this.contentAlteredValues.contacts) {
        return this.contentAlteredValues.contacts[index + 1];
      }
      return false;
    }
  }
};

</script>
